import React from "react";
import { AlertTriangle, RefreshCw } from "lucide-react";
import { Button } from "../../../../shadcn/ui/button";

const ErrorState = ({
  title = "Something went wrong",
  message,
  onRetry,
  retryLabel = "Try again",
  className = "",
  showIcon = true,
}) => {
  return (
    <div className={`p-6 bg-red-50 rounded-lg border border-red-200 ${className}`}>
      <div className="flex items-start gap-3">
        {showIcon && <AlertTriangle className="w-5 h-5 text-red-500 flex-shrink-0 mt-0.5" />}
        <div className="flex-1">
          <h3 className="text-sm font-medium text-red-800 mb-1">{title}</h3>
          {message && <p className="text-sm text-red-700 mb-3">{message}</p>}
          {onRetry && (
            <Button
              variant="outline"
              size="sm"
              onClick={onRetry}
              className="text-red-700 border-red-300 hover:bg-red-100"
            >
              <RefreshCw className="w-4 h-4 mr-2" />
              {retryLabel}
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

export default ErrorState;
